import { gql } from '@apollo/client'

export const enterPinMutation = gql`
  mutation enterPin($pinCode: String!) {
    enterPin(pinCode: $pinCode) {
      pinBlocked
      remainRetries
      success
    }
  }
`
